/**
 * 欢迎项目数据
 * 用于创建示例项目，展示 Tempo 的功能
 */

export interface WelcomeTaskData {
  title: string;
  notes?: string;
  done?: boolean;
  vital?: boolean;
  urgent?: boolean;
  fixed?: boolean;
  startAt?: string;
  cost?: number;
  dueAt?: string;
}

export interface WelcomeProjectData {
  title: string;
  context: string;
  tasks: WelcomeTaskData[];
}

/**
 * 生成带时间的欢迎项目数据
 * 为部分任务设置今天的时间，按1小时间隔错开
 */
export const generateWelcomeProjectData = (): WelcomeProjectData => {
  const today = new Date();

  // 设置基础时间为今天下午3点
  const baseTime = new Date(today);
  baseTime.setHours(15, 0, 0, 0); // 15:00

  // 生成不同时间点
  const getTimeSlot = (hourOffset: number): string => {
    const time = new Date(baseTime);
    time.setHours(baseTime.getHours() + hourOffset);
    return time.toISOString();
  };

  return {
    title: "了解 Tempo",
    context: "通过完成这些任务来学习 Tempo 的功能",
    tasks: [
      {
        title: "✅ 点击完成这个任务试试看",
        notes: "这是您的第一个任务！点击任务查看或者编辑任务详情，左侧的圆圈来标记完成，体验任务完成的感觉。",
        done: false,
        vital: false,
        urgent: false,
        startAt: getTimeSlot(0), // 今天下午3点
        cost: 3600 // 1小时
      },
      {
        title: "📝 创建一个新任务：买菜",
        notes: "练习使用 + 按钮创建任务。试试创建一个\"买菜\"任务，体验任务创建流程。",
        done: false,
        vital: false,
        urgent: false,
        startAt: getTimeSlot(0), // 今天下午3点
        cost: 3600 // 1小时
      },
      {
        title: "⏰ 点击任务并为任务设置时间：今天下午3点开会",
        notes: "学习为任务设置具体时间。点击编辑这个任务，设置开会时间为今天下午3点。",
        done: false,
        vital: false,
        urgent: false,
        startAt: getTimeSlot(0), // 今天下午3点
        cost: 3600 // 1小时
      },
      {
        title: "🎯 标记重要任务：准备明天的演示",
        notes: "学习使用四象限管理。编辑这个任务，将它标记为重要且紧急。",
        done: false,
        vital: false,
        urgent: false,
        startAt: getTimeSlot(1), // 今天下午4点
        cost: 7200 // 2小时
      },
      {
        title: "🤖 与 AI 聊天：让它帮你规划周末",
        notes: "切换到聊天页面，问 AI：\"帮我规划一个充实的周末\"，体验 AI 助手功能。",
        done: false,
        vital: false,
        urgent: false,
        startAt: getTimeSlot(2), // 今天下午5点
        cost: 1800 // 30分钟
      },
      {
        title: "📊 切换视图：查看时间轴模式",
        notes: "尝试切换到时间轴视图，看看任务在时间线上的分布。",
        done: false,
        vital: false,
        urgent: false,
        startAt: getTimeSlot(3), // 今天下午7点
        cost: 900 // 15分钟
      },
      {
        title: "🔄 时间轴拖拽任务：重新安排时间",
        notes: "试试在时间轴模式下拖拽任务到不同的时间段，体验灵活的时间管理。",
        done: false,
        vital: false,
        urgent: false,
        startAt: getTimeSlot(4), // 今天下午6点
        cost: 1800 // 30分钟
      },
      {
        title: "🎉 恭喜！您已经掌握了 Tempo 的基本功能",
        notes: "现在您可以开始创建自己的项目和任务了。这个示例项目可以保留作为参考，也可以删除。",
        done: false,
        vital: false,
        urgent: false
        // 保持无时间，作为总结任务
      }
    ]
  };
};

// 保持原有的静态数据导出，用于向后兼容
export const welcomeProjectData: WelcomeProjectData = generateWelcomeProjectData();
